import axios from "../plugins/parseAxios";
export class InvoiceAPI {
  static getMonthlyInvoices(projectId, marketId, month, year, contractIds) {
    return axios.post("functions/getMonthlyInvoices", {
      projectId,
      marketId,
      month,
      year,
      contractIds
    });
  }
  static getMonthlyInvoiceByContract(contractId, month, year) {
    return axios.post("functions/getMonthlyInvoiceByContract", {
      contractId,
      month,
      year
    });
  }
  static getInvoicesByContract(payload) {
    return axios.post("functions/getInvoicesByContract", payload)
  }
  static getInvoicesBySchedulerTask(payload) {
    return axios.post("functions/getInvoicesBySchedulerTask", payload)
  }
  static getInvoicesByContractInAppeal(payload) {
    return axios.post("functions/getInvoicesByContractInAppeal", payload)
  }
  static getInvoicesRecognizanceByContract(payload) {
    return axios.post("functions/getInvoicesRecognizanceByContract", payload)
  }
  static createInvoice(payload) {
    return axios.post("functions/createInvoice", payload)
  }
  static createBookingInvoice(payload) {
    return axios.post("functions/createBookingInvoice", payload)
  }
  static getInvoice(invoiceId) {
    return axios.post("functions/getInvoice", {
      id: invoiceId
    });
  }
  static updateInvoice(postData) {
    return axios.post("functions/updateInvoice", postData);
  }
  static sendInvoice({ id, date, dueDate }) {
    return axios.post("functions/sendInvoice", {
      id,
      date,
      dueDate
    });
  }
  static unsendInvoice(invoiceId) {
    return axios.post("functions/unsendInvoice", {
      id: invoiceId
    });
  }
  static cancelInvoice(invoiceId) {
    return axios.post("functions/cancelInvoice", {
      id: invoiceId
    });
  }
  static getInvoicesBetweenDateByProject(fromData) {
    return axios.post("functions/getInvoicesBetweenDateByProject", fromData);
  }
  static getInvoicesBetweenDateByMarket(fromData) {
    return axios.post("functions/getInvoicesBetweenDateByMarket", fromData);
  }
  static reCalculateMonthlyInvoice(invoiceId) {
    return axios.post("functions/reCalculateMonthlyInvoice", {
      id: invoiceId
    });
  }
  static getInvoicesSentByContract(payload) {
    return axios.post("functions/getInvoicesSentByContract", payload)
  }
  static getUnpaidInvoicesByMarket(payload) {
    return axios.post("functions/getUnpaidInvoicesByMarket", payload);
  }
  static getUnpaidInvoicesByProject(fromData) {
    return axios.post("functions/getUnpaidInvoicesByProject", fromData);
  }
  static getBookingInvoicesByMarket(marketId) {
    return axios.post("functions/getBookingInvoicesByMarket", {
      marketId
    });
  }
  static generateInvoiceItems(meterData) {
    return axios.post("functions/generateInvoiceItems", {
      meterData,
    });
  }
  static removeInvoice(invoiceId) {
    return axios.post("functions/removeInvoice", {
      id: invoiceId
    });
  }
  static updateInvoiceCustomerData(postData) {
    return axios.post("functions/updateInvoiceCustomerData", postData);
  }
  static cancelInvoiceInvoicePayment(invoiceId) {
    return axios.post("functions/cancelInvoiceInvoicePayment", {
      id: invoiceId
    });
  }
  static getPenaltyMonthlyInvoices(projectId, marketId, month, year, contractIds) {
    return axios.post("functions/getPenaltyMonthlyInvoices", {
      projectId,
      marketId,
      month,
      year,
      contractIds
    });
  }

  //Overall Invoice
  static getOverAllInvoices(payload) {
    return axios.post("functions/getOverAllInvoices", payload)
  }
  static getOverAllMonthlyInvoices(payload) {
    return axios.post("functions/getOverAllMonthlyInvoices", payload)
  }
  static getOverAllYearlyInvoices(payload) {
    return axios.post("functions/getOverAllYearlyInvoices", payload)
  }
  static sendInvoices(payload) {
    return axios.post("functions/sendInvoices", payload)
  }
}
